import { connect } from 'react-redux'
import {
  stepAboutLogo,
  stepSector,
  stepValues,
  stepEmotions,
  stepVisualInspiration,
  // stepColorPalettes,
  // stepTypefaces,
  stepType,
  stepKeywords,
  stepLogoPreviews,
  stepLogoDownload,
  updateSelectedLanguage
} from '../actions/new-logo'
import NewLogo from '../components/NewLogo'

const mapStateToProps = (state) => {
  return {
    newLogo: state.newLogo,
    authenticatedUser: state.users.status === "authenticated" ? state.users.user : null
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    stepAboutLogo: () => {
      dispatch(stepAboutLogo())
    },
    stepSector: () => {
      dispatch(stepSector())
    },
    stepValues: () => {
      dispatch(stepValues())
    },
    stepEmotions: () => {
      dispatch(stepEmotions())
    },
    stepType: () => {
      dispatch(stepType())
    },
    stepVisualInspiration: () => {
      dispatch(stepVisualInspiration())
    },
    // stepColorPalettes: () => {
    //   dispatch(stepColorPalettes())
    // },
    // stepTypefaces: () => {
    //   dispatch(stepTypefaces())
    // },
    stepKeywords: () => {
      dispatch(stepKeywords())
    },
    stepLogoPreview: () => {
      dispatch(stepLogoPreviews())
    },
    stepLogoDownload: () => {
      dispatch(stepLogoDownload())
    },
    updateLanguage: (lang) => {
      dispatch(updateSelectedLanguage(lang))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewLogo)



// WEBPACK FOOTER //
// ./src/containers/NewLogo.js